<!-- Compact until previewed: auto height hugs the composer + footer; the consequences slip rolls the
     bottom down when it mounts (vrequest 2026-06-10). -->
<dx-popup [width]="1160" [height]="'auto'" [maxHeight]="800" title="Retro-fills" [showTitle]="true"
   [closeOnOutsideClick]="false" [resizeEnabled]="true" [dragEnabled]="true"
   [visible]="isVisible" (onHidden)="onHidden()">
   <div *dxTemplate="let data of 'content'" class="bd-root">

      <!-- Where the structure lands (per-leg Target Group routes within the Combo). Opened from a COMBO
           row there is no Group segment — every leg picks its target explicitly. -->
      <div class="bd-hierarchy" *ngIf="comboName">
         <span class="h-label">Portfolio:</span> <span class="h-name">"{{ portfolioName }}"</span>
         <span class="h-arrow">&#8594;</span>
         <span class="h-label">Combo:</span> <span class="h-name">"{{ comboName }}"</span>
         <ng-container *ngIf="groupName">
            <span class="h-arrow">&#8594;</span>
            <span class="h-label">Group:</span> <span class="h-name">"{{ groupName }}"</span>
         </ng-container>
      </div>

      <!-- The composer: one underlying drives every option leg's chain (single-underlying package). -->
      <div class="bd-underlying">
         <span class="bd-fld-label">Underlying</span>
         <div class="bd-underlying-row">
            <ets-symbol-picker [selectedInstrument]="instrument" (instrumentSelected)="onSymbolSelected($event)"></ets-symbol-picker>
            <div class="bd-add-actions">
               <dx-button text="Add Asset" [disabled]="!canAddAsset" (onClick)="addAsset()"></dx-button>
               <dx-button text="Add Option" (onClick)="addOption()"></dx-button>
            </div>
         </div>
      </div>

      <div class="bd-leg-head">
         <span>Leg</span><span>Action</span><span>Qty</span><span>Expiration</span>
         <span>Type</span><span>Strike</span><span>Avg Price</span><span>Target Group</span><span>Date/Time</span><span></span>
      </div>

      <dx-scroll-view direction="vertical" [showScrollbar]="'onHover'" height="170" class="bd-legs-scroll">
         <div class="bd-legs">
            <ng-container *ngFor="let leg of assetLegs; trackBy: trackLeg">
               <ng-container *ngTemplateOutlet="legRow; context: { $implicit: leg }"></ng-container>
            </ng-container>
            <div class="bd-leg-divider" *ngIf="assetLegs.length > 0 && optionLegs.length > 0"></div>
            <ng-container *ngFor="let leg of optionLegs; trackBy: trackLeg">
               <ng-container *ngTemplateOutlet="legRow; context: { $implicit: leg }"></ng-container>
            </ng-container>
         </div>
      </dx-scroll-view>

      <!-- ONE action line. The consequences now open as a POPUP (owner, round 10): Preview -> spinner
           -> the slip popup carrying the commit decision. The main footer keeps only Preview + Cancel. -->
      <div class="bd-footer">
         <div class="bd-footer-left">
            <dx-button text="Preview Result" type="default" [disabled]="busy || !legs.length" (onClick)="onPreview()"></dx-button>
            <dx-load-indicator class="bd-spin" [visible]="busy" height="20" width="20"></dx-load-indicator>
         </div>
         <div class="bd-footer-right">
            <dx-button text="Cancel" (onClick)="onCancel()"></dx-button>
         </div>
      </div>

      <!-- One leg row. Option-only controls are wrapped in a cell span so asset rows keep grid alignment.
           Expiration/Strike use the shared ETS pickers, disabled until an underlying is chosen. -->
      <ng-template #legRow let-leg>
         <div class="bd-leg-row" [class.is-asset]="!isOption(leg)">
            <!-- Expired legs colorize the label (the 48px track has no room for a badge — it overlapped
                 the Side dropdown); the slip's Retro Expirations section is the full signal. -->
            <span class="bd-kind-label" [class.is-expired]="isExpiredLeg(leg)"
               [attr.title]="isExpiredLeg(leg) ? 'Past expiration — commit will retro-expire and settle it' : null">{{ isOption(leg) ? 'Option' : 'Asset' }}</span>
            <dx-select-box class="cell" [dataSource]="sides" displayExpr="text" valueExpr="id" [(value)]="leg.side"
               (onValueChanged)="onLegChanged()" fieldTemplate="field">
               <div *dxTemplate="let data of 'field'">
                  <dx-text-box [readOnly]="true" [value]="data?.text"
                     [inputAttr]="{ style: 'text-align:center;font-weight:600;color:' + ((data && data.id === 1) ? '#4d8fd6' : '#e05656') }"></dx-text-box>
               </div>
               <div *dxTemplate="let data of 'item'">
                  <span [style.color]="(data && data.id === 1) ? '#4d8fd6' : '#e05656'" style="font-weight:600">{{ data?.text }}</span>
               </div>
            </dx-select-box>
            <dx-number-box class="cell" placeholder="Qty" [(value)]="leg.qty" [showSpinButtons]="false" (onValueChanged)="onLegChanged()"></dx-number-box>
            <!-- Expired contract: the chain lists only LIVE expirations — the toggle swaps the chain
                 selector for a typed past date (+ a series-root pick when the chain shows several, e.g.
                 SPX(M) vs SPXW). LAYOUT CONTRACT (rounds 7-8 lesson): every picker must stay a DIRECT
                 child of .cell — the row grid sizes them via ".cell > *"; wrapping them breaks it. -->
            <span class="cell bd-exp-cell">
               <ets-expiration-selector *ngIf="isOption(leg) && !leg.useCustomExpiration"
                  [expirationDescriptors]="expirationsList"
                  [(selectedExpiration)]="leg.expiration"
                  (expirationChanged)="onLegChanged()"
                  [showClearButton]="true"
                  [disabled]="!instrument">
               </ets-expiration-selector>
               <ets-datetime-picker *ngIf="isOption(leg) && leg.useCustomExpiration" mode="date"
                  placeholder="Expiration" [(value)]="leg.customExpiration"
                  (valueChange)="onLegChanged()"></ets-datetime-picker>
               <dx-select-box *ngIf="isOption(leg) && leg.useCustomExpiration && chainRoots.length > 1"
                  class="bd-exp-root" [dataSource]="chainRoots"
                  [(value)]="leg.customRoot" (onValueChanged)="onLegChanged()"></dx-select-box>
               <dx-button *ngIf="isOption(leg)" class="bd-exp-toggle"
                  [icon]="leg.useCustomExpiration ? 'revert' : 'clock'"
                  stylingMode="text"
                  [hint]="leg.useCustomExpiration ? 'Back to listed expirations' : 'Expired contract — type its expiration date'"
                  (onClick)="toggleCustomExpiration(leg)"></dx-button>
            </span>
            <span class="cell">
               <dx-select-box *ngIf="isOption(leg)" [dataSource]="optionTypes" [displayExpr]="'text'" [valueExpr]="'id'"
                  [(value)]="leg.optionType" (onValueChanged)="onLegChanged()"></dx-select-box>
            </span>
            <span class="cell">
               <ets-strikes-dropdown *ngIf="isOption(leg) && !leg.useCustomExpiration"
                  [targetInstrument]="instrument"
                  [expiration]="leg.expiration"
                  [(strike)]="leg.strike"
                  [(atmStrike)]="leg.strike"
                  [showAtm]="true"
                  (strikeChanged)="onLegChanged()"
                  (atmStrikeChanged)="onLegChanged()"
                  [disable]="!instrument">
               </ets-strikes-dropdown>
               <!-- Expired contract: no chain, no strike list — the strike is typed (the user records
                    what the broker filled; enter-only). -->
               <dx-number-box *ngIf="isOption(leg) && leg.useCustomExpiration" placeholder="Strike"
                  [min]="0" [(value)]="leg.strike" [showSpinButtons]="false" (onValueChanged)="onLegChanged()"></dx-number-box>
            </span>
            <dx-number-box class="cell" placeholder="Avg Price" [(value)]="leg.avgPx" [showSpinButtons]="false"
               [format]="{ style: 'currency', currency: 'USD' }" (onValueChanged)="onLegChanged()"></dx-number-box>
            <!-- Per-leg routing target: the locked Combo's Groups (same Portfolio + Combo; only the Group varies). -->
            <span class="cell">
               <dx-select-box [dataSource]="routingGroups" displayExpr="name" valueExpr="bucketId"
                  [(value)]="leg.targetGroupBucketId" placeholder="Group" (onValueChanged)="onLegChanged()"></dx-select-box>
            </span>
            <!-- REQUIRED per-leg trade time: calendar + time + zone (per-leg valid-time, owner decision). -->
            <span class="cell bd-date-cell">
               <!-- (timezoneChange) alongside the banana (same dual-listener pattern as [(value)] +
                    (valueChange) here): a tz-only edit must invalidate the preview like any other
                    leg edit — it changes the leg's UTC instant. -->
               <ets-datetime-picker mode="datetime" [showTimezone]="true" [(timezone)]="leg.tradeTz"
                  (timezoneChange)="onLegChanged()"
                  [(value)]="leg.tradeDate" (valueChange)="onLegChanged()"></ets-datetime-picker>
            </span>
            <dx-button class="bd-remove-leg" icon="close" stylingMode="text" hint="Remove leg" (onClick)="removeLeg(leg.id)"></dx-button>
         </div>
      </ng-template>
   </div>
</dx-popup>

<!-- The consequences POPUP (owner, round 10): opens when the preview result arrives and carries the
     settlement slip + the COMMIT decision (informed confirm — the price/settlement inputs live here).
     Closing it discards the preview; the next Preview recomputes against the current legs. -->
<dx-popup [width]="920" [height]="'auto'" [maxHeight]="700" title="Preview Result" [showTitle]="true"
   [closeOnOutsideClick]="false" [dragEnabled]="true" [resizeEnabled]="true"
   [visible]="previewPopupVisible" (onHidden)="onPreviewPopupHidden()">
   <div *dxTemplate="let data of 'content'" class="bd-root">

      <div class="bd-preview" *ngIf="preview">
         <div class="bd-slip">
            <div class="bd-info" *ngIf="!preview.isRetro">
               No leg is in the past — record forward entry through the Make Transaction dialog instead.
            </div>
            <div class="bd-blocked" *ngIf="preview.blockedReason">{{ preview.blockedReason }}</div>

            <ng-container *ngIf="preview.isRetro && !preview.blockedReason">
               <div class="bd-section" *ngIf="preview.priceNeeds?.length">
                  <div class="bd-slip-title bd-need-title">Prices Needed &#8212; Supply Each to Commit</div>
                  <table class="bd-table">
                     <tr><th>Instrument</th><th>As of</th><th>Price</th></tr>
                     <tr *ngFor="let n of preview.priceNeeds">
                        <td>{{ dispName(n.tradingInstrumentCode) }}</td>
                        <td>{{ n.asOfUtc | date:'short' }}</td>
                        <td class="bd-price-cell">
                           <!-- Per-keystroke commit through the decorated handler: the Commit gate
                                (canCommit) reads this map — the DX default 'change' commit left the
                                button disabled until blur, and this box sat outside the onLegChanged
                                convention every other editor follows. -->
                           <dx-number-box [min]="0" valueChangeEvent="input"
                              [value]="priceInputs[needKey(n)]"
                              (valueChange)="onPriceNeedChange(n, $event)"></dx-number-box>
                        </td>
                     </tr>
                  </table>
               </div>

               <!-- Retro expirations: option legs already past expiration settle at expiry (4:20 PM ET)
                    inside the same atomic commit. Outcome is auto-derived; the settlement level is
                    editable — a changed value commits as the operator's mark and wins over the fetch. -->
               <div class="bd-section" *ngIf="preview.syntheticExpiries?.length">
                  <div class="bd-slip-title">Retro Expirations &#8212; Settled at Expiry</div>
                  <table class="bd-table">
                     <tr><th>Instrument</th><th>Outcome</th><th>Settlement</th><th>Settled At</th></tr>
                     <tr *ngFor="let x of preview.syntheticExpiries">
                        <td>{{ dispName(x.optionInstrumentCode) }}</td>
                        <td class="bd-outcome" [ngClass]="outcomeClass(x.outcome)">{{ outcomeLabel(x.outcome) }}</td>
                        <td class="bd-price-cell">
                           <!-- Same decorated-handler commit as the Prices-Needed box (no gate reads this
                                map, but the edited value feeds onCommit's manual-mark build). -->
                           <dx-number-box [min]="0" valueChangeEvent="input"
                              [value]="expiryPriceInputs[expiryKey(x)]"
                              (valueChange)="onExpiryPriceChange(x, $event)"></dx-number-box>
                        </td>
                        <!-- Date only (owner, round 11) — the settle TIME is the same constant for every
                             option (4:20 PM ET), so it carries no information. The UTC calendar day of
                             settleTimeUtc IS the expiration day (20:20Z/21:20Z, never past midnight). -->
                        <td>{{ x.settleTimeUtc | date:'EEE, dd-MMM-yyyy':'UTC' }}</td>
                     </tr>
                  </table>
               </div>

               <div class="bd-section" *ngIf="preview.positionChanges?.length">
                  <div class="bd-slip-title">Positions Affected</div>
                  <table class="bd-table">
                     <tr><th>Change</th><th>Instrument</th><th>Net</th><th>Avg Px</th><th>Accum P&amp;L</th></tr>
                     <tr *ngFor="let p of preview.positionChanges">
                        <td class="bd-change" [ngClass]="changeClass(p)">{{ changeOf(p) }}</td>
                        <td>{{ dispName(p.tradingInstrumentCode) }}</td>
                        <td class="bd-num">{{ p.netBefore }} &#8594; {{ p.netAfter }}</td>
                        <td class="bd-num">{{ p.avgPxBefore | currency:'USD':'symbol':'1.2-2' }} &#8594; {{ p.avgPxAfter | currency:'USD':'symbol':'1.2-2' }}</td>
                        <td class="bd-num">{{ p.accumulatedBefore | currency:'USD':'symbol':'1.2-2' }} &#8594; {{ p.accumulatedAfter | currency:'USD':'symbol':'1.2-2' }}</td>
                     </tr>
                  </table>
               </div>

               <div class="bd-section bd-clean" *ngIf="!preview.positionChanges?.length && !preview.priceNeeds?.length">
                  No positions change — this structure folds in cleanly.
               </div>
            </ng-container>
         </div>
      </div>

      <div class="bd-footer">
         <div class="bd-footer-left"></div>
         <div class="bd-footer-right">
            <dx-button text="Close" [disabled]="busy" (onClick)="onPreviewPopupClose()"></dx-button>
            <dx-button text="Commit Retro-fills" type="danger" [disabled]="!canCommit()" (onClick)="onCommit()"></dx-button>
         </div>
      </div>
   </div>
</dx-popup>
